module.exports = __webpack_public_path__ + "static/Q5Answer3_Pink_w-8b4e2413f1b9ce4bb70626d94b2965bd.jpg";